module.exports = __webpack_public_path__ + "media/images/common/update_order-a26bbf68f593f020ff8156ffd6174db1.png";